import React, { Fragment, useState, useEffect } from "react";
import PropTypes, { array } from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Moment from "react-moment";
import {
  getJobPosts,
  getJobPostsByTerms,
  getAppliedJobs,
  apply,
  applyIME,
  applyIMEResume,
  deleteApplication,
  deleteUserApplication,
  clearJobs,
} from "../../actions/job";

import LoggedOutNavAlt from "../layout/IME/LoggedOutNavAlt";
import LoggedInNav from "../layout/IME/LoggedInNav";
import HomeFooterAlt from "../layout/IME/HomeFooterAlt";
import JobItem from "../layout/Employers/JobItem";
import UploadResume from "../layout/IME/UploadResume";
import AppliedSuccess from "../layout/IME/AppliedSuccess";
import Applied from "../layout/IME/Applied";
import ApplicationRemoved from "../layout/IME/ApplicationRemoved";
import EmploymentTypeItem from "../layout/Employers/EmploymentTypeItem";
import SalaryItem from "../layout/Employers/SalaryItem";
import CompanyItem from "../layout/Employers/CompanyItem";
import LocationItem from "../layout/Employers/LocationItem";
import RemoveApplication from "../layout/IME/RemoveApplication";

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const Jobs = ({
  auth: { user },
  isAuthenticated,
  getAppliedJobs,
  getJobPosts,
  getJobPostsByTerms,
  job: { jobs, applied_jobs, applicant, comments, jobloading },
  apply,
  applyIME,
  applyIMEResume,
  deleteApplication,
  deleteUserApplication,
  clearJobs,
}) => {
  const [text, setText] = useState({ jobtitle: "", location: "" });
  const [foundJob, setFoundJob] = useState(false);
  const [comment, setComment] = useState("");
  const [Job, setshowJob] = useState({
    _id: "",
    channelid: "",
    companyname: "",
    avatar: "",
    jobtitle: "",
    location: {},
    keywords: [],
    jobdescription: "",
    jobsummary: "",
    environment: "",
    employmenttype: "",
    salary: 0,
    responsibilities: [],
    qualifications: [],
    benefits: [],
    comments: [],
    vrtour: "",
    jobstream: "",
    date: "",
  });
  const [attachmentFile, setAttachmentFile] = useState({
    file: "",
    email: "",
    docType: "docx",
  });
  const [attachmentDataFile, setAttachmentDataFile] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [addAttachment, setShowAddAttachment] = useState(false);
  const [removeApp, setRemoveApp] = useState(false);
  const [filters, setFilters] = useState({
    employmenttype: "",
    salary: 0,
    companyname: "",
    location: "",
  });
  const [isChecked, setIsChecked] = useState({
    employmenttype: false,
    salary: false,
    companyname: false,
    location: false,
  });

  const jobId = Job._id;

  const jobChannelId = Job.channelid;

  useEffect(() => {
    getAppliedJobs();
    getJobPosts();
  }, [getAppliedJobs, getJobPosts]);

  useEffect(() => {
    if (
      applied_jobs &&
      applied_jobs.isArray &&
      applied_jobs.length > 0 &&
      Job._id !== ""
    ) {
      applied_jobs.map((x) => {
        if (x._id.toString() === Job._id) {
          setFoundJob(true);
        } else {
          setFoundJob(false);
        }
      });
    }
  }, [Job._id, applied_jobs]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }

  if (
    (isAuthenticated && user && user.channelid === "roland") ||
    (isAuthenticated && user && user.channelid === "imeemployer") ||
    (isAuthenticated && user && user.channelid === "imeinnovator")
  ) {
    return (
      <Fragment>
        {applicant && applicant.msg === "Application Removed" && (
          <ApplicationRemoved clearJobs={clearJobs} />
        )}
        {!isAuthenticated &&
          applicant.email == attachmentFile.email &&
          applicant.email !== undefined && (
            <AppliedSuccess
              isAuthenticated={isAuthenticated}
              user={user}
              applicant={applicant}
              attachmentFile={attachmentFile}
              setAttachmentFile={setAttachmentFile}
              clearJobs={clearJobs}
            />
          )}
        {isAuthenticated &&
          applicant.channelid == user.channelid &&
          applicant.channelid !== undefined && (
            <AppliedSuccess
              isAuthenticated={isAuthenticated}
              user={user}
              applicant={applicant}
              attachmentFile={attachmentFile}
              setAttachmentFile={setAttachmentFile}
              clearJobs={clearJobs}
            />
          )}
        {removeApp && (
          <RemoveApplication
            user={user}
            clearJobs={clearJobs}
            jobId={jobId}
            jobChannelId={jobChannelId}
            deleteUserApplication={deleteUserApplication}
            setRemoveApp={setRemoveApp}
          />
        )}
        {applicant &&
          applicant.msg &&
          applicant.msg ===
            "Oops! Looks like you have already applied to this position. Would you like to withdraw your pending application?" && (
            <Applied
              isAuthenticated={isAuthenticated}
              user={user}
              applicant={applicant}
              attachmentFile={attachmentFile}
              setAttachmentFile={setAttachmentFile}
              clearJobs={clearJobs}
              jobId={jobId}
              jobChannelId={jobChannelId}
              deleteApplication={deleteApplication}
            />
          )}
        <div className="light-body">
          {addAttachment && (
            <UploadResume
              setShowAddAttachment={setShowAddAttachment}
              setAttachmentFile={setAttachmentFile}
              attachmentFile={attachmentFile}
              setAttachmentDataFile={setAttachmentDataFile}
              attachmentDataFile={attachmentDataFile}
              setAttachments={setAttachments}
              attachments={attachments}
              setFiles={setFiles}
              files={files}
              Job={Job}
              isAuthenticated={isAuthenticated}
              user={user}
              applyIMEResume={applyIMEResume}
              jobId={jobId}
              jobChannelId={jobChannelId}
            />
          )}
          {!isAuthenticated && <LoggedOutNavAlt />}
          {isAuthenticated && <LoggedInNav />}
          <section className="jobs-hero">
            <div className="hero-jobs border-left border-right border-bottom light-grey">
              <div className="job-search-container">
                <div>
                  <form
                    className="form-flex"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (text.jobtitle !== "" || text.location !== "") {
                        getJobPostsByTerms(text);
                        setText({ jobtitle: "", location: "" });
                      }
                    }}
                  >
                    <div className="label-input">
                      <label htmlFor="jobsearch" className="labels black bold">
                        Job Title<i className="fas fa-search mx-5 black"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden-light">
                          <input
                            className="job-input"
                            type="text"
                            name="text"
                            value={text.jobtitle}
                            onChange={(e) =>
                              setText({ ...text, jobtitle: e.target.value })
                            }
                            placeholder="Enter Job Title or Employer Name"
                          />
                        </div>
                        {text.jobtitle !== "" && (
                          <div className="job-location-results">
                            <div className="profile-drop-container">
                              <i className="fas fa-search fa-lg drop-down-icon white"></i>
                              <p className="drop-down-text">Job Result</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="label-input">
                      <label
                        htmlFor="joblocation"
                        className="labels black bold"
                      >
                        Location
                        <i className="fas fa-location-arrow black mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden-light">
                          <input
                            className="job-input"
                            type="text"
                            name="locationtext"
                            value={text.location}
                            onChange={(e) =>
                              setText({ ...text, location: e.target.value })
                            }
                            placeholder="Enter City or State"
                          />
                          <button
                            className="search-button background-black"
                            onClick={(e) => {
                              e.preventDefault();
                              if (
                                text.jobtitle !== "" ||
                                text.location !== ""
                              ) {
                                getJobPostsByTerms(text);
                                setText({ jobtitle: "", location: "" });
                              }
                            }}
                          >
                            <i className="fas fa-search white"></i>
                          </button>
                        </div>
                        {text.location !== "" && (
                          <div className="job-location-results">
                            <div className="profile-drop-container">
                              <i className="fas fa-location-arrow fa-lg drop-down-icon white"></i>
                              <p className="drop-down-text">Locations</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="post-section">
              <div className="job-post-box">
                <div className="search-box">
                  {jobs && jobs.length > 0 && (
                    <h4 className="box-message">
                      10,743 Results for Search Results
                      <br />
                      near City, State
                    </h4>
                  )}
                  <div className="link-container">
                    <h1 className="desc-border">Job Search</h1>
                  </div>
                  <form className="job-search">
                    {/* <select className="job-select" name="distance-select">
                    <option className="select-value" value="Within 10 Miles">
                      Within 10 Miles
                    </option>
                    <option className="select-value" value="Exact Location">
                      Exact Location
                    </option>
                    <option className="select-value" value="Within 5 Miles">
                      Within 5 Miles
                    </option>
                    <option className="select-value" value="Within 15 Miles">
                      Within 15 Miles
                    </option>
                    <option className="select-value" value="Within 20 Miles">
                      Within 20 Miles
                    </option>
                    <option className="select-value" value="Within 25 Miles">
                      Within 25 Miles
                    </option>
                    <option className="select-value" value="Within 50 Miles">
                      Within 50 Miles
                    </option>
                    <option className="select-value" value="Within 100 Miles">
                      Within 100 Miles
                    </option>
                  </select> */}
                    {jobs && jobs.isArray && jobs.length > 0 && (
                      <label className="select-font mt-20" htmlFor="job-type">
                        Employment Type
                      </label>
                    )}
                    {jobs &&
                      jobs.map((item, index) => {
                        return (
                          <EmploymentTypeItem
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            setFilters={setFilters}
                            filters={filters}
                            item={item}
                            key={index}
                          />
                        );
                      })}
                    {jobs && jobs.length > 0 && (
                      <label className="select-font mt-20" htmlFor="job-type">
                        Salary
                      </label>
                    )}
                    {jobs &&
                      jobs.map((item, index) => {
                        return (
                          <SalaryItem
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            setFilters={setFilters}
                            filters={filters}
                            item={item}
                            key={index}
                            formatter={formatter}
                          />
                        );
                      })}
                    {jobs && jobs.length > 0 && (
                      <label className="select-font mt-20" htmlFor="job-type">
                        Company
                      </label>
                    )}
                    {jobs &&
                      jobs.map((item, index) => {
                        return (
                          <CompanyItem
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            setFilters={setFilters}
                            filters={filters}
                            item={item}
                            key={index}
                          />
                        );
                      })}
                    {jobs && jobs.length > 0 && (
                      <label className="select-font mt-20" htmlFor="job-type">
                        Location
                      </label>
                    )}
                    {jobs &&
                      jobs.map((item, index) => {
                        return (
                          <LocationItem
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            setFilters={setFilters}
                            filters={filters}
                            item={item}
                            key={index}
                          />
                        );
                      })}
                    <p className="site-phrase">
                      <i className="fas fa-globe-americas fa-lg"></i> Life is
                      better when we innovate <br />
                      <span className="phrase">Together.</span>
                    </p>
                  </form>
                </div>
                <div className="job-post-listing-container">
                  {jobs && jobs.length <= 0 && (
                    <p className="empty-content-light">
                      No Matched Job Post Results
                    </p>
                  )}
                  {jobs &&
                    jobs.length > 0 &&
                    jobs.map((post) => (
                      <JobItem
                        key={post._id}
                        post={post}
                        Job={Job}
                        setshowJob={setshowJob}
                        formatter={formatter}
                        stateComments={comments}
                      />
                    ))}
                </div>
                <div className="job-desc">
                  <div className="link-container border-bottom light-grey">
                    <h1 className="desc-border mt-20">Job Description</h1>
                  </div>
                  {Job.jobtitle === "" && (
                    <p className="empty-content-light">No Selected Job Post</p>
                  )}
                  {Job.jobtitle !== "" && (
                    <div className="desc-body">
                      <div className="job-preview">
                        <div className="job-post-banner">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${Job.avatar}`}
                            className="job-post-avi-alt"
                          />
                        </div>
                      </div>
                      <div className="job-preview">
                        <div className="flex-start">
                          <ul>
                            <li className="post-job-title">{Job.jobtitle}</li>
                            <li className="job-post-li">{Job.companyname}</li>
                            <li className="job-post-li">
                              {Job.location.city}, {Job.location.state}
                            </li>
                            <ul>
                              <li className="job-post-keywords">
                                <i className="fas fa-business-time mr-5"></i>
                                {Job.employmenttype}
                              </li>
                              {Job.salary === 0 ? (
                                <li className="job-post-keywords">
                                  <i className="far fa-money-bill-alt mr-5"></i>
                                  Salary Not Available
                                </li>
                              ) : (
                                <li className="job-post-keywords">
                                  <i className="far fa-money-bill-alt mr-5"></i>
                                  {formatter.format(Job.salary)}
                                </li>
                              )}
                              <li className="job-post-keywords">
                                <i className="far fa-building mr-5"></i>
                                {Job.environment}
                              </li>
                            </ul>
                            {Job.vrtour !== "" && (
                              <li className="keywords-job-post black">
                                <i className="fas fa-street-view fa-sm black times-sm mx-10"></i>
                              </li>
                            )}
                            {Job.jobstream !== "" && (
                              <li className="keywords-job-post black">
                                <i className="fas fa-video fa-sm black times-sm mx-10"></i>
                              </li>
                            )}
                            <li className="job-post-li">
                              <i className="far fa-clock bold fa-sm black times-sm mr-5"></i>
                              <Moment format="MM/DD/YYYY">{Job.date}</Moment>
                            </li>
                            {isAuthenticated &&
                              user.role === "innovator" &&
                              foundJob === false && (
                                <div className="apply">
                                  <button
                                    className="apply-now green background-black"
                                    onClick={() => setShowAddAttachment(true)}
                                  >
                                    Apply
                                  </button>
                                </div>
                              )}
                            {foundJob && (
                              <div className="apply">
                                <button
                                  onClick={() => setRemoveApp(true)}
                                  className="apply-now black background-green"
                                >
                                  Applied
                                  <i className="far fa-circle-check fa-lg mx-5"></i>
                                </button>
                              </div>
                            )}
                            {!isAuthenticated && (
                              <div className="apply">
                                <button
                                  className="apply-now green background-black"
                                  onClick={() => setShowAddAttachment(true)}
                                >
                                  Apply
                                </button>
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="job-preview-keywords">
                        <ul>
                          {Job.keywords.length > 0 &&
                            Job.keywords.map((keyword) => {
                              return (
                                <li
                                  className="job-post-keywords"
                                  key={keyword._id}
                                >
                                  {keyword.text}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div className="sub-section-container-alt">
                        <div className="flex-only">
                          <p className="sub-section black bold">Description</p>
                        </div>
                        <p className="desc-paragraph">{Job.jobdescription}</p>
                      </div>
                      <div className="sub-section-container-alt">
                        <div className="flex-only">
                          <p className="sub-section black bold">Job Summary</p>
                        </div>
                        <p className="desc-paragraph">{Job.jobsummary}</p>
                      </div>
                      <div className="sub-section-container-alt">
                        <div className="flex-only">
                          <p className="sub-section black bold">
                            Responsibilities
                          </p>
                        </div>
                        <ul className="desc-paragraph jobs-comment-text mb-20">
                          {Job.responsibilities.length > 0 &&
                            Job.responsibilities.map((responsibility) => {
                              return (
                                <li
                                  className="resp-item"
                                  key={responsibility._id}
                                >
                                  <i className="fas fa-star-of-life grey mx-r-5"></i>
                                  {responsibility.text}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div className="sub-section-container-alt">
                        <div className="flex-only">
                          <p className="sub-section black bold">
                            Qualifications
                          </p>
                        </div>
                        <ul className="desc-paragraph jobs-comment-text mb-20">
                          {Job.qualifications.length > 0 &&
                            Job.qualifications.map((qualification) => {
                              return (
                                <li
                                  className="resp-item"
                                  key={qualification._id}
                                >
                                  <i className="fas fa-star-of-life grey mx-r-5"></i>
                                  {qualification.text}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div className="sub-section-container-alt">
                        <div className="flex-only">
                          <p className="sub-section black bold">Benefits</p>
                        </div>
                        <ul className="desc-paragraph jobs-comment-text mb-20">
                          {Job.benefits.length > 0 &&
                            Job.benefits.map((benefit) => {
                              return (
                                <li className="resp-item" key={benefit._id}>
                                  <i className="fas fa-star-of-life grey mx-r-5"></i>
                                  {benefit.text}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          {!isAuthenticated &&
            attachmentFile.file !== "" &&
            attachmentFile.email !== "" &&
            !addAttachment && (
              <div className="submit-changes-dark">
                <button
                  className="submit-changes-button background-dark-black white"
                  onClick={() => {
                    apply(attachmentFile, files, jobChannelId, jobId);
                    setAttachmentDataFile("");
                    setFiles([]);
                    setAttachments([]);
                    setAttachmentFile({
                      file: "",
                      email: "",
                      docType: "docx",
                    });
                  }}
                >
                  Apply
                </button>
              </div>
            )}
          {isAuthenticated && attachmentFile.file !== "" && !addAttachment && (
            <div className="submit-changes-dark">
              <button
                className="submit-changes-button background-dark-black white"
                onClick={() => {
                  applyIME(attachmentFile, files, jobChannelId, jobId);
                  setAttachmentDataFile("");
                  setFiles([]);
                  setAttachments([]);
                  setAttachmentFile({
                    file: "",
                    email: "",
                    docType: "docx",
                  });
                }}
              >
                Apply
              </button>
            </div>
          )}
          <HomeFooterAlt />
        </div>
      </Fragment>
    );
  }
};

Jobs.propTypes = {
  getAppliedJobs: PropTypes.func.isRequired,
  getJobPosts: PropTypes.func.isRequired,
  getJobPostsByTerms: PropTypes.func.isRequired,
  apply: PropTypes.func.isRequired,
  applyIME: PropTypes.func.isRequired,
  applyIMEResume: PropTypes.func.isRequired,
  deleteApplication: PropTypes.func.isRequired,
  deleteUserApplication: PropTypes.func.isRequired,
  addJobComment: PropTypes.func.isRequired,
  deleteJobComment: PropTypes.func.isRequired,
  clearJobs: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  job: state.job,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getAppliedJobs,
  getJobPosts,
  getJobPostsByTerms,
  apply,
  applyIME,
  applyIMEResume,
  deleteApplication,
  deleteUserApplication,
  clearJobs,
})(Jobs);
